import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "asFooter" }
const _hoisted_2 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.footer, (col, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "asFooter_col",
        key: i,
        innerHTML: col
      }, null, 8, _hoisted_2))
    }), 128))
  ]))
}